import { render, staticRenderFns } from "./shareOrderAudit.vue?vue&type=template&id=18dd01c2&scoped=true&"
import script from "./shareOrderAudit.vue?vue&type=script&lang=js&"
export * from "./shareOrderAudit.vue?vue&type=script&lang=js&"
import style0 from "./shareOrderAudit.vue?vue&type=style&index=0&id=18dd01c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd01c2",
  null
  
)

component.options.__file = "shareOrderAudit.vue"
export default component.exports